import { render } from "./container-header.vue?vue&type=template&id=67363fde&scoped=true&ts=true"
import script from "./container-header.vue?vue&type=script&lang=ts"
export * from "./container-header.vue?vue&type=script&lang=ts"

import "./container-header.vue?vue&type=style&index=0&id=67363fde&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67363fde"]])

export default __exports__